// src/components/richText/index.tsx
import { Language } from '@/types/language.types'
import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'
import dynamic from 'next/dynamic'

const RichTextClient = dynamic(() => import('./RichTextClient'), {
  ssr: true,
  loading: () => <div className="animate-pulse bg-muted h-24 rounded" />,
})

type Props = {
  data: DefaultTypedEditorState
  enableGutter?: boolean
  enableProse?: boolean
  lang?: Language
} & React.HTMLAttributes<HTMLDivElement>

export default function RichText(props: Props) {
  return <RichTextClient {...props} />
}